export type TransphereBannerVariant =
    | 'not-subscribed'
    | 'subscribed-no-encaissement'
    | 'encaissement-subscription-inactive';

/** What the Acomba desktop path knows about Transphere, straight off the bridge's company read. */
export interface DesktopTransphereFacts {
    connected: boolean;
    /** Whether the company read answered at all — a failed read must not pass as "not subscribed". */
    companyResolved: boolean;
    transphereActive: boolean | null;
    transphereUniqueId: string | null;
    encaissementActif: boolean;
    receiptSubscription: boolean | null;
}

/**
 * Whether the société can actually be paid through Transphere.
 *
 * `CCTransphereActive` says the société wants to collect and never moves when the subscription lapses,
 * so collecting takes both halves. An unread subscription falls back to the configuration alone, as the
 * backend gate does: a read that never reached Transphere must not retire the feature.
 */
export function isDesktopEncaissementActive(
    encaissementActif: boolean,
    receiptSubscription: boolean | null,
): boolean {
    return encaissementActif && (receiptSubscription ?? true);
}

/** Which banner the desktop path's own facts call for; null shows none. */
export function desktopTransphereBannerVariant(facts: DesktopTransphereFacts): TransphereBannerVariant | null {
    if (!facts.connected || !facts.companyResolved) return null;

    const subscribed = facts.transphereActive ?? Boolean(facts.transphereUniqueId);
    if (!subscribed) return 'not-subscribed';
    if (!facts.encaissementActif) return 'subscribed-no-encaissement';
    // Every other feature has retired the offer by now, so the banner states the cause rather than
    // leaving a société that believes it collects to watch its payment links vanish.
    if (facts.receiptSubscription === false) return 'encaissement-subscription-inactive';
    return null;
}
